import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthGuard } from './guards/auth.guard';

export const usermgmtRoutes: Routes = [
  { path: "authentication",loadChildren: () => import("./modules/authentication/authentication.module").then(m => m.AuthenticationModule) },
  {
    path: "users",
    loadChildren: () => import('./pages/user/user.module').then(m => m.UserModule),
    canActivate: [AuthGuard],
    data: {resource: "USER"}
  },
  {
    path: "applications",
    loadChildren: () => import('./pages/applications/applications.module').then(m => m.ApplicationsModule),
    canActivate: [AuthGuard],
    data: {resource: "APPLICATION"}
  },
  {
    path: "roles",
    loadChildren: () => import('./pages/profiles/profiles.module').then(m => m.ProfilesModule),
    canActivate: [AuthGuard],
    data: {resource: "ROLE"}
  },
  {
    path: "customer",
    loadChildren: () => import('./pages/customer/customer.module').then(m => m.CustomerModule),
    canActivate: [AuthGuard],
    data: {resource: "CUSTOMER"}
  },
  { path: '**', redirectTo: 'users', pathMatch: 'full' }
]

@NgModule({
  declarations: [
  ],
  imports: [
    RouterModule.forChild(usermgmtRoutes),
    NgSelectModule
  ],
  exports: [
  ]
})

export class UsermgmtModule { }


